import React, { useState, useRef, useEffect, useContext } from 'react'
import { isEmpty } from 'AccountsUtils'
import { Button } from '@cleartrip/bento/components/Button'
import { formatCurrency } from 'Utils'
import { AccountsContext } from 'AccountsContext'
import { getWalletUrl } from '../../utils/walletUtils'

import { getHiFiveDetails } from '../../pages/Trips/trips.helper'
import { DownChevronBlack, TickIcon } from '../../assets/svgs/hiFive/index'
import ShareBtnContainer from './ShareBtnContainer'

const SignUpStatus = ({
  requiredSignUpCount,
  signedUpUsers,
  cycleExpirationTime,
  isTimerStart,
  rewardAmount,
  signupReward,
  referralLinkHifive,
  rewardProgressArray,
  referralLinkEndStr
}) => {
  const mountedRef = useRef(true)
  const pollTimeInSeconds = 30
  const [friendlist, setFriendList] = useState(false)
  const [newSignups, setNewSignups] = useState([])
  const { hifiveStates, setHifiveStates } = useContext(AccountsContext)
  const signedUpUsersList = newSignups?.length > 0 ? newSignups : signedUpUsers
  const getHiFiveHands = () => {
    return (
      <ul className="flex flex-middle flex-center  px-10 " style={{ gap: '8px' }}>
        {Array.from({ length: requiredSignUpCount }, (_, i) => i).map(num => {
          return (
            <li
              className={` ba bc-neutral-900 br-12 flex flex-center flex-middle h-24 w-24 
            ${num < signedUpUsersList?.length ? 'bg-white' : ''}`}
              style={{ borderWidth: '0.5px' }}
            >
              <If condition={num < signedUpUsersList?.length}>
                <TickIcon width="13" height="13" />
                <If condition={num !== (requiredSignUpCount - 1)}>
                  <div className="hifive-signup-active p-relative" />
                </If>
              </If>
            </li>
          )
        })}
      </ul>
    )
  }

  const pollSignedUpUsers = async () => {
    if (!mountedRef.current) {
      return
    }
    const hiFiveInfoResponse = await getHiFiveDetails()
    const { status, data } = hiFiveInfoResponse
    if (status === 200 && !isEmpty(data)) {
      if (hifiveStates?.isRunning) {
        if (data.statusDetails?.referralStatus === 'SUCCESS') {
          window.location.reload()
        } else if (data.statusDetails?.referralStatus !== 'SUCCESS' &&
          data.registeredReferrals) {
          setNewSignups(data?.registeredReferrals)
          setHifiveStates({
            ...hifiveStates,
            signedUpUsersList: data?.registeredReferrals
          })

          await new Promise(resolve => setTimeout(resolve, pollTimeInSeconds * 1000))
          await pollSignedUpUsers()
        } else {
          await pollSignedUpUsers()
        }
      }
    }
  }

  function toggle() {
    setFriendList(!friendlist)
  }

  useEffect(() => {
    const timer1 = setTimeout(() => {
      pollSignedUpUsers()
    }, pollTimeInSeconds * 1000)

    return () => {
      clearTimeout(timer1)
      mountedRef.current = false
    }
  }, [isTimerStart])

  let caption = 'No friends have signed up so far'
  if (!signedUpUsersList || !requiredSignUpCount) {
    caption = ''
  } else {
    const remainingSignUps = requiredSignUpCount - signedUpUsersList.length

    if (remainingSignUps === 1) {
      caption = 'Just 1 more friend has to sign up'
    } else if (remainingSignUps === 2) {
      caption = '2 more friends have to sign up'
    } else if (signedUpUsersList?.length === 1) {
      caption = '1 friend has signed up so far'
    } else if (signedUpUsersList?.length > 0) {
      caption = `${signedUpUsersList.length} friends have signed up so far`
    }
  }

  const handleCta = () => {
    window.location.href = getWalletUrl()
  }

  let totalRewardValue = 0

  if (signedUpUsersList) {
    totalRewardValue = signedUpUsersList.reduce((total, item) => {
      return total + item.rewardAmount
    }, 0)
  }

  return (
    <React.Fragment>
      {hifiveStates?.isSuccess && (
        <div className="py-4 px-4 bg-white ba bc-black btr-16  ta-center ">
          <p className="fw-500 fs-16">{signedUpUsersList?.length} friends gave you Hi-Five!</p>
        </div>
      )}
      <div className="bb bbr-16 bc-black bg-light-green bl br">
        <If condition={(hifiveStates?.isRunning)}>
          <p className="c-neutral-900 fs-24 lh-32 fw-500 ta-center pt-4">Total earnings of {formatCurrency(totalRewardValue)}</p>
          <div onClick={signedUpUsersList.length > 0 ? toggle : undefined }>
            <p className=" c-pointer c-neutral-900 flex flex-center flex-middle fs-11 fs-12
            fw-400 lh-14 pt-1 ta-center"
            >
              {caption}
              <span className={`flex-center flex-middle 
              ${friendlist ? 'upChevron' : 'downChevron'}
              ${(signedUpUsersList?.length > 0) ? 'flex' : 'd-none'}`}
              >
                <span className={`${friendlist ? 'chevronUp' : 'chevronDown'} `}>
                  <DownChevronBlack />
                </span>
              </span>
            </p>
          </div>
        </If>

        <div id="overlay">
          <div className="mb-32 mt-32 pb-6  px-6 w-320">

            <section className={`pt-4 ${hifiveStates?.isSuccess ? 'pb-4' : 'pb-6'}`}>
              {(!friendlist && !hifiveStates?.isSuccess) && <div>{getHiFiveHands()}</div>}

              {(friendlist || hifiveStates?.isSuccess) && (
                <div id="friendList">
                  <If condition={(signedUpUsersList?.length > 0) ||
                    (hifiveStates?.isSuccess)}
                  >
                    <ul
                      style={{ bottom: '62px', gap: '12px' }}
                      className="pt-2 flex flex-column"
                    >
                      {Array.from(
                        {
                          length: hifiveStates?.isSuccess
                            ? signedUpUsersList?.length
                            : requiredSignUpCount
                        },
                        (_, i) => i
                      ).map(num => {
                        return (
                          <li className="flex flex-middle flex-between">
                            <div className="flex flex-middle flex-center">
                              {!hifiveStates?.isSuccess && (
                                <li
                                  className={`ba bw-05 bc-neutral-900 br-12 flex flex-center 
                                 flex-middle h-24 mr-3 w-24 
                                 ${signedUpUsersList[num] ? 'bg-white' : ''}`}
                                  >
                                    <If condition={signedUpUsersList[num]}>
                                      <div className={`${(requiredSignUpCount?.length - 1) !== num &&
                                       'hifive-signup-list'}  p-relative`}
                                      />
                                      <TickIcon width="12" height="12" />
                                    </If>

                                  </li>
                                )}
                                <p className="fs-14 lh-24 c-neutral-900">
                                  {signedUpUsersList[num] ? signedUpUsersList[num].displayName : '-'}
                                </p>
                              </div>
                              <p className="fs-14 lh-16 c-neutral-900 fw-500">
                                {formatCurrency(rewardProgressArray[num])}
                              </p>

                            </li>
                          )
                        })
                      }
                    </ul>
                  </If>
                </div>
              )}
            </section>
            {(hifiveStates?.isRunning && referralLinkHifive) && (
              <ShareBtnContainer
                referralLink={referralLinkHifive}
                rewardAmount={rewardAmount}
                signupReward={signupReward}
                referralLinkEndStr={referralLinkEndStr}
              />
            )}

            {hifiveStates?.isSuccess && (
              <Button
                onClick={handleCta}
                className="br-8-imp w-100p fs-4 fw-600 py-2 h-10
                hover:bg-neutral-900
                 bg-neutral-900"
              >
                Check wallet
              </Button>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default SignUpStatus
